export const PROPERTY_PATH_MAP = {
  report: {
    path: 'id',
    dataType: 'string',
  },
  date: {
    path: 'createdAt',
    dataType: 'date',
  },
  time: {
    path: 'createdAt',
    dataType: 'date',
  },
};
